<script>
  import controller from './controller'
  const { script } = controller()
  export default script
</script>

<template>
  <div>
    <p class="title" v-if="showTitle"> {{ title }} </p>
    <p class="sub-title" v-if="showSubTitle"> {{ subTitle }} </p>

    <template v-if="showCollaborators">
      <!-- Contenido a paginar -->
      <div v-for="(item, index) in paginatedItems" :key="index" class="mb-3 my-item-retraction">

        <!-- Información respuesta del permiso -->
        <b-row class="my-row">
          <b-col>
            <b-row class="pb-4">
              <b-col class="box">
                <strong>Colaborador</strong>: {{ getModifiedEmployeeName(item) }}
                <br>
                <strong>Gestión del permiso</strong>: {{ formatStateManagement(item) }}
                <br>
                <strong>fecha</strong>: {{ $moment(item.updated_at).format('DD [de] MMMM [de] YYYY [-] h:m A') }}
                <br>
                <strong>Fechas de permiso aprobados:
                  <span v-for="(day, idx_day) in getDaysApproved(item)"
                        :key="idx_day"> {{ day.day | moment('DD') }}{{ ((getDaysApproved(item).length - 1) > idx_day) ? ',' : null }}
                  </span>
                  <template v-if="getLastDay(getDaysApproved(item))">{{ getLastDay(getDaysApproved(item)) | moment('[de] MMMM [de] YYYY') }}</template>
                </strong>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <p class="sub-title pt-4"> Información adicional para retractarse </p>

        <!-- Informacion adicional -->
        <b-row class="my-row">
          <b-col cols="12">
            <b-row class="pb-4">
              <p>
                Selecciona los días de retractación para el colaborador {{ item.collaborator_name }}
              </p>
              <b-col class="box pb-4" cols="12">
                <b-form-radio-group>
                  <label class="switch-container"
                         v-for="(day, idx_btn) in getDaysApproved(item)"
                         :key="'btn'.concat(idx_btn)">
                    <input type="checkbox"
                           v-model="selectedCollaborator"
                           :id="day.id"
                           :value="{ id:item.id,  day: day.id }">
                    <div class="checkbox-slider">
                      <span class="on">{{ day.day | moment('DD') }}</span>
                      <span class="off">{{ day.day | moment('DD') }}</span>
                    </div>
                  </label>
                  <template v-if="getLastDay(getDaysApproved(item))">
                    <span class="switch-container-span">
                      {{ getLastDay(getDaysApproved(item)) | moment('MMMM [de] YYYY') }}
                    </span>
                  </template>
                </b-form-radio-group>

                <a href=""
                   @click.prevent="approvedAll(item)"
                   style="color: #000000">
                  todos los días
                </a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

      </div>

      <!-- text area del motivo -->
      <template v-if="showMotive">
        <p class="sub-title pt-4"> Motivo de retractación </p>

        <b-row class="my-row">
            <b-form-textarea
                id="textarea-no-resize"
                placeholder="Motivo de retractación"
                rows="5"
                no-resize
                v-model.trim="motive"
                :state="validationMotive"
            ></b-form-textarea>
        </b-row>
      </template>

      <!-- Paginacion -->
      <template v-if="showPagination">
        <b-pagination class="justify-content-center pt-3"
                      v-model="currentPage"
                      :total-rows="totalItems"
                      :per-page="perPage"
                      first-number
                      hide-goto-end-buttons
                      aria-controls="my-item-retraction" />
      </template>

    </template>

    <template v-else>
      <div class="box">
        <p class="box-body">
          <span class="box-body-bold">Fecha y hora:</span> {{ $moment(createdAt).format('DD [de] MMMM [de] YYYY [-] h:m A') }}
          <br>
          <span class="box-body-bold">Solicitante:</span> {{ capitalizeText(name) }}
        </p>
      </div>
    </template>
  </div>
</template>

<style lang="scss" src="./styles.scss" />